export default "__VITE_ASSET__D0sQ80OO__"